import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CaptainsComponent } from './captains.component';
import { CaptainsResolve } from './captains.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/captains',
        component: CaptainsComponent,
        resolve: {
          captains: CaptainsResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class CaptainsRoutingModule {}
